import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { 
  HomeIcon, 
  BuildingStorefrontIcon,
  ChartBarIcon,
  CogIcon,
  ShieldCheckIcon,
  CurrencyDollarIcon
} from '@heroicons/react/24/outline';
import { useAuth } from '../../contexts/AuthContext';
import { useVendor } from '../../contexts/VendorContext';
import AppShell from './AppShell';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const { user, logout } = useAuth();
  const { currentVendor } = useVendor();
  const location = useLocation();
  const navigate = useNavigate();
 
  const navigation = [
    { name: 'لوحة التحكم', href: '/', icon: HomeIcon, current: location.pathname === '/' },
    { name: 'إدارة البائعين', href: '/vendors', icon: BuildingStorefrontIcon, current: location.pathname.startsWith('/vendors') },
    { name: 'إدارة الاشتراكات', href: '/admin/subscription-plans', icon: CurrencyDollarIcon, current: location.pathname.startsWith('/admin/subscription-plans') },
    { name: 'التقارير المالية', href: '/financial-reports', icon: CurrencyDollarIcon, current: location.pathname.startsWith('/financial-reports') },
    { name: 'إحصائيات النظام', href: '/system-stats', icon: ChartBarIcon, current: location.pathname.startsWith('/system-stats') },
    { name: 'إعدادات النظام', href: '/system-settings', icon: CogIcon, current: location.pathname.startsWith('/system-settings') },
    { name: 'الأمان والصلاحيات', href: '/security', icon: ShieldCheckIcon, current: location.pathname.startsWith('/security') },
  ];

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <AppShell
      brandTitle="إدارة النظام"
      brandSubtitle="لوحة مدير النظام"
      brandIcon={ShieldCheckIcon}
      navigation={navigation}
      userName={user?.fullName}
      userSubtitle="مدير النظام"
      userCaption={currentVendor?.vendorName || 'مدير النظام'}
      roleBadge="مدير النظام"
      headerExtras={
        <span className="hidden items-center gap-2 rounded-full bg-green-50 px-3 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20 lg:inline-flex">
          <span className="h-2 w-2 rounded-full bg-green-500" />
          النظام يعمل
        </span>
      }
      onLogout={handleLogout}
    >
      {children}
    </AppShell>
  );
};

export default AdminLayout; 